import { http } from '../http';
import { extrairMensagemErro } from '../../utils/apiError';

interface AssociadoCadastroResponse {
  mensagem: string;
  status: string;
  resposta_api: any;
}

export interface EnviarParaSgaResponse {
  acao: 'CADASTRO' | 'ALTERACAO_SITUACAO' | string;
  cpfCnpj: string;
  id: string;
  resultado: any;
}

export const cadastrarAssociadoSga = async (associadoData: any): Promise<AssociadoCadastroResponse> => {
  try {
    const response = await http.post('/sga-associado/cadastrar', associadoData);

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const alterarSituacaoAssociado = async (codigoAssociado: string): Promise<void> => {
  try {
    await http.post(`/sga-associado/alterar-situacao/${codigoAssociado}`, {});
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Erro ao alterar situação do associado');
  }
};

export const enviarAssociadoParaSgaPorCpfCnpj = async (
  cpfCnpj: string
): Promise<EnviarParaSgaResponse> => {
  const doc = (cpfCnpj ?? '').trim();
  if (!doc) throw new Error('CPF/CNPJ é obrigatório.');

  try {
    const response = await http.post(
      `/sga-associado/enviarParaSga/${encodeURIComponent(doc)}`,
      {}
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(extrairMensagemErro(error, 'Erro ao enviar associado para o SGA'));
  }
};
